import { render, staticRenderFns } from "./conge.vue?vue&type=template&id=552ed188&scoped=true"
import script from "./conge.vue?vue&type=script&lang=js"
export * from "./conge.vue?vue&type=script&lang=js"
import style0 from "./conge.vue?vue&type=style&index=0&id=552ed188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552ed188",
  null
  
)

export default component.exports